import { useSelector } from "react-redux";
import { useMemo } from "react";
import i18n from "./i18n";
import languageData from "../assets/languageData.json";

export const useMenuAuthInfo = () => {
  const menuAuthInfo = useSelector((state) => state.menuAuth.menuAuthInfo);

  const menuAuth = menuAuthInfo?.find(
    (menuAuth) =>
      menuAuth.url &&
      (window.location.pathname.startsWith(menuAuth.url + "/") ||
        window.location.pathname === menuAuth.url)
  );

  return menuAuth ? Object.freeze({ ...menuAuth }) : null;
};

export const useMultiLang = (type) => {
  const multiLang = useSelector((state) => state.multiLang?.multiLang);

  return useMemo(() => {
    if (!Array.isArray(multiLang)) {
      return [];
    }

    return multiLang
      .filter((data) => data.type === type && data[i18n.language])
      .map((data) => ({
        code: data.code,
        codeDesc: data[i18n.language],
      }));
  }, [multiLang, type]);
};

export const getLanguageText = (code) => {
  return languageData[code] || code;
};
